export default class DtoProblemSolutionLink {
    constructor(obj) {
        this.id = obj.id
        this.idProblem = obj.idProblem
        this.idSolution = obj.idSolution
    }
}